import { useTranslations } from 'next-intl';
import { CatIconHide } from 'blocks-nextjs/blocks-react/components/Icons/Hide';
import { CatIconCloseCircle } from 'blocks-nextjs/blocks-react/components/Icons/CloseCircle';
import { CatTooltip } from 'blocks-nextjs/blocks-react/components/Tooltip';
import { CatTextPassage } from 'blocks-nextjs/blocks-react/components/TextPassage';
import { CatButton } from 'components/blocks-components';
import styles from './notification-card-header-actions.module.scss';

const NotificationCardHeaderActions = ({
  isDismissed,
  handleDismiss,
  dynamicClassName = ''
}: {
  isDismissed: boolean;
  handleDismiss?: () => void;
  dynamicClassName?: string;
}) => {
  const t = useTranslations();

  return (
    <div className={styles['header-actions']}>
      <CatTooltip
        data-testid="notification-dismissed-tooltip"
        className={!isDismissed ? dynamicClassName : ''}
      >
        {isDismissed ? (
          <>
            <CatIconHide
              slot="trigger"
              aria-label={t('NOTIFICATIONS_DISMISSED_HOVER_LABEL')}
            />
            <CatTextPassage size="xs">
              {t('NOTIFICATIONS_DISMISSED_HOVER_LABEL')}
            </CatTextPassage>
          </>
        ) : (
          <>
            <CatButton
              hideText
              variant="ghost"
              slot="trigger"
              onClick={handleDismiss}
              size="xs"
              className={styles['header-actions__dismiss-button']}
            >
              <CatIconCloseCircle
                aria-label={t('NOTIFICATIONS_DISMISS')}
                slot="before"
              />
            </CatButton>
            <CatTextPassage size="xs">
              {t('NOTIFICATIONS_DISMISS')}
            </CatTextPassage>
          </>
        )}
      </CatTooltip>
    </div>
  );
};

export default NotificationCardHeaderActions;
